/*
  Shared client-side GC number index (Shopify search does not index metafields).
  Built from /search?view=gc, fetched in parallel and cached on the device for 12h so
  the header dropdown and the search page share one download.

  window.nbsGcIndex.load(onBatch) -> Promise<products[]>
    onBatch(products) is called with each page as it arrives (or once with the whole
    cached index), so callers can show matches before the download finishes.
  window.nbsGcIndex.prefetch() starts a background load without a callback.
*/
(function () {
  if (window.nbsGcIndex) return;

  var KEY = 'nbs_b2b_gc_index_v2';
  var TTL = 12 * 60 * 60 * 1000;
  var CONCURRENCY = 8;

  var memory = null;
  var loading = null;
  var listeners = [];

  function readCache() {
    var stores = [];
    try { stores.push(window.localStorage); } catch (e) {}
    try { stores.push(window.sessionStorage); } catch (e) {}
    for (var i = 0; i < stores.length; i++) {
      try {
        var raw = stores[i] && stores[i].getItem(KEY);
        if (!raw) continue;
        var parsed = JSON.parse(raw);
        if (parsed && parsed.ts && Date.now() - parsed.ts < TTL && Array.isArray(parsed.products)) {
          return parsed.products;
        }
      } catch (e) {}
    }
    return null;
  }

  function writeCache(products) {
    var payload = JSON.stringify({ ts: Date.now(), products: products });
    try {
      window.localStorage.setItem(KEY, payload);
      return;
    } catch (e) {}
    try { window.sessionStorage.setItem(KEY, payload); } catch (e) {}
  }

  function fetchPage(page) {
    return fetch('/search?view=gc&type=product&q=placeholder&page=' + page, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('GC index page ' + page + ' failed');
      return r.json();
    });
  }

  function fetchWithRetry(page) {
    return fetchPage(page).catch(function () { return fetchPage(page); });
  }

  function emit(batch) {
    if (!batch || !batch.length) return;
    listeners.forEach(function (fn) {
      try { fn(batch); } catch (e) {}
    });
  }

  function load(onBatch) {
    if (memory || (memory = readCache())) {
      if (onBatch) onBatch(memory);
      return Promise.resolve(memory);
    }
    if (onBatch) listeners.push(onBatch);
    if (loading) return loading;

    var failed = false;
    loading = fetchWithRetry(1)
      .then(function (first) {
        var total = Math.max(1, Number(first.pages || first.total_pages || 1));
        var pages = [];
        pages[1] = Array.isArray(first.products) ? first.products : [];
        emit(pages[1]);

        var next = 2;
        function worker() {
          if (next > total) return Promise.resolve();
          var page = next++;
          return fetchWithRetry(page)
            .then(function (data) {
              pages[page] = Array.isArray(data.products) ? data.products : [];
              emit(pages[page]);
            }, function () {
              failed = true;
              pages[page] = [];
            })
            .then(worker);
        }

        var workers = [];
        for (var i = 0; i < CONCURRENCY; i++) workers.push(worker());
        return Promise.all(workers).then(function () {
          var all = [];
          for (var p = 1; p <= total; p++) if (pages[p]) all = all.concat(pages[p]);
          memory = all;
          if (!failed) writeCache(all);
          return all;
        });
      })
      .catch(function () {
        memory = null;
        return [];
      })
      .then(function (all) {
        loading = null;
        listeners = [];
        return all;
      });

    return loading;
  }

  window.nbsGcIndex = {
    load: load,
    prefetch: function () { load(); }
  };
})();
